import { render, staticRenderFns } from "./boxing.vue?vue&type=template&id=38762389"
import script from "./boxing.vue?vue&type=script&lang=js"
export * from "./boxing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports